import React from 'react';
import { TextField, MenuItem } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles';
import { useSelector, useDispatch } from 'react-redux';
import ACTIONS from 'redux-lib/actions/actions';
import Autocomplete from '@material-ui/lab/Autocomplete';

const useStyles = makeStyles((theme) => ({
  root: {
    '& .MuiTextField-root': {
      width: '25ch',
    },
  },
  select: {
    '& .MuiSelect-icon': {
      color: '#3f88b1'
    }
  }
}));

function AONSelect(props) {
  const classes = useStyles(); 

  const dispatch = useDispatch();
  const states = useSelector(state => {
    return state.globalStates
  })

  const aon = states ? states.aon ? states.aon : "" : "";
  const aon_options = states ? states.aon_options ? states.aon_options.optionFields : [] : [];
  const handleChange = (e, newValue) => {
    dispatch({
      type: ACTIONS.UPDATE_AON,
      payload: newValue
    })
  }

  return(
    <div className={ classes.root }>
      <Autocomplete
        id="autocomplete-car-aon"
        options={aon_options}
        getOptionLabel={(option) => option.label ? option.label : ""}
        getOptionSelected={(option, value) => option.label === value.label}
        autoSelect={true}
        autoHighlight={true}
        onChange={handleChange}
        loading={ states.aon }
        loadingText="Loading..."
        value={ aon }
        renderInput={(params) => (
          <TextField
            { ...params }
            id="standard-select-aon"
            name="aon"
            label="AON"
            className={ classes.select }
            InputLabelProps={{
              shrink: true
            }}
          />
        )}
      />
    </div>
  )
}

export default AONSelect;